<template>
    <div>
        <v-row>
            <v-col>
                <a style="text-decoration: none; color: black" @click="$router.push({ name: 'UserTraining' })">&larr; Tilbage til oversigt</a>
            </v-col>
        </v-row>
        <v-divider />
        <loader v-if="loading" />
        <template v-else>
            <v-row>
                <v-col>
                    <v-row align="center">
                        <v-col>
                            <h2>{{ selectedLesson.name }}</h2>
                        </v-col>
                        <v-col cols="5" lg="4">
                            <v-btn
                                :disabled="!selectedLesson.agents[this.uniqueId].completed"
                                x-large
                                class="white--text"
                                color="primary"
                                style="width: 100%"
                                to="/test"
                                
                            >
                                Tag test
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider />
            <v-row>
                <v-col cols="12" lg="8">
                    <v-card tile id="video-player">
                        <video-player
                            class="vjs-custom-skin vjs-show-big-play-button-on-pause"
                            ref="videoPlayer"
                            :options="playerOptions"
                            @ready="handlePlayerReadied"
                            @timeupdate="handleTimeUpdate"
                            @ended="videoEnded"
                        />
                    </v-card>
                </v-col>
                <v-col cols="12" lg="4">
                    <v-card tile>
                        <v-tabs v-model="tab">
                            <v-tab>Kapitler</v-tab>
                            <v-tab>Filer</v-tab>
                        </v-tabs>
                        <template v-if="tab === 0">
                            <v-card-text v-if="!selectedLesson.chapters.length" :style="$vuetify.breakpoint.mobile ? '' : chapterListStyle">
                                Der er ingen kapitler til denne video.
                            </v-card-text>
                            <v-list v-else :style="$vuetify.breakpoint.mobile ? '' : chapterListStyle">
                                <v-list-item-group>
                                    <template v-for="(chapter, index) in selectedLesson.chapters">
                                        <v-list-item
                                            :key="'a' + index"
                                            @click="skipToTimestamp(chapter.timestamp)"
                                            :disabled="timeWatched < chapter.timestamp"
                                            :class="{'v-item--active v-list-item--active' : currentTime >= chapter.timestamp && (!chapters[index + 1] || currentTime < chapters[index + 1].timestamp)}"
                                            :input-value="currentTime >= chapter.timestamp && (!chapters[index + 1] || currentTime < chapters[index + 1].timestamp)"
                                        >
                                            <v-list-item-title>
                                                <v-row>
                                                    <v-col class="flex-grow-0">
                                                        {{ chapter.name }}
                                                    </v-col>
                                                    <v-col>
                                                        <v-icon v-if="timeWatched <= chapter.timestamp" class="mr-2">fa-lock</v-icon></v-col>
                                                    <v-col class="text-right">
                                                        {{ chapter.timestamp | timestamp }}
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-divider :key="'b' + index"/>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </template>
                        <template v-else-if="tab === 1">
                            <v-list class="striped-list" :style="$vuetify.breakpoint.mobile ? '' : chapterListStyle">
                                <v-list-item v-for="(file, index) in selectedLesson.files" :key="index">
                                    <v-list-item-icon>
                                        <v-icon :color="($store.state.training.fileIcons[file.filename.split('.').reverse()[0]] || { color: '#000' }).color">
                                            {{ ($store.state.training.fileIcons[file.filename.split('.').reverse()[0]] || { icon: 'far fa-file' }).icon }}
                                        </v-icon>
                                    </v-list-item-icon>                            
                                    <v-list-item-title>
                                        {{ file.name }}
                                    </v-list-item-title>
                                    <v-list-item-action>
                                        <v-btn icon>
                                            <v-icon v-ripple color="primary" @click="downloadFile(file)">fa-download</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </template>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </div>
</template>

<script>
import 'video.js/dist/video-js.css'

import { videoPlayer } from 'vue-video-player'

export default {
    components: {
        videoPlayer
    },
    data () {
        return {
            tab: 0,
            loading: true,
            timeWatched: 1,
            timer: null,
            currentTime: 0,
            lastTime: 0,
            chapterListStyle: null
        }
    },
    computed: {
        selectedLesson () {
            return this.$store.state.training.selectedLesson
        },
        playerOptions () {
            return {
                fluid: true,
                autoplay: true,
                sources: [{
                    type: "video/mp4",
                    src: this.videoSrc
                }]
            }
        },
        uniqueId () {
            return this.$store.state.main.uniqueId
        }
    },
    methods: {
        async videoEnded () {
            await this.$http().post(`user/${this.uniqueId}/training/lessons/${this.selectedLesson._id}/videoCompleted`)
            this.selectedLesson.agents[this.uniqueId].completed = true
        },
        async downloadFile ({ filename }) {
            const response = await this.$http().get(`training/file/${filename}`)
            const link = document.createElement('a')
            link.href = response.data
            link.click()
        },
        skipToTimestamp (timestamp) {
            this.$refs.videoPlayer.player.currentTime(timestamp)
            this.$refs.videoPlayer.player.play()
        },
        handleTimeUpdate () {
            if (this.selectedLesson.agents[this.uniqueId].completed) return null
            this.currentTime = this.$refs.videoPlayer.player.currentTime()
            if (this.currentTime > this.timeWatched + 2) this.$refs.videoPlayer.player.currentTime(this.timeWatched)
            else {
                this.timeWatched = this.currentTime
                let dbTimeWatched = this.selectedLesson.agents[this.uniqueId].timeWatched
                if (!dbTimeWatched || this.timeWatched - dbTimeWatched > 5) {
                    this.selectedLesson.agents[this.uniqueId].timeWatched = this.timeWatched
                    this.$http().put(`user/${this.uniqueId}/training/lessons/${this.selectedLesson._id}/timestamp`, this.timeWatched)
                }
            }
        },
        handlePlayerReadied () {
            const player = document.getElementById('video-player')
            this.chapterListStyle = `overflow-y: auto; height: ${player.clientHeight - 48}px`
            this.$refs.videoPlayer.player.currentTime(this.timeWatched)
        },
        async getData () {
            this.loading = true
            const response = await this.$http().get(`training/video/${this.selectedLesson.filename}`)
            this.videoSrc = response.data
            this.timeWatched = this.selectedLesson.agents[this.uniqueId].timeWatched || 1
            this.loading = false
        }
    },
    created () {
        if (!this.selectedLesson) this.$router.push({ name: 'UserTraining' })
        else this.getData()
    }
}
</script>

<style lang="scss">
.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause .vjs-big-play-button {
    display: block;
}
</style>